module.exports = __webpack_public_path__ + "img/violet_004.3f88ebcf.png";